//import { multiMap } from '../map/map-multi.js';

export default {
  init() {
    //multiMap();
    function homeHeroSpacing() {
      let windowHeight = $(window).height()
      let windowWidth = $(window).width()
      let marginTop = (windowWidth > 992) ? 50 : 100
      let navBarHeight = (windowHeight > 992) ? $('#navbar').height() : marginTop
      let sliderHeight = windowHeight - navBarHeight

      $('#home-slider').css({
          'height': sliderHeight + 'px',
          'marginTop': navBarHeight + 'px',
      })

      $('.carousel-item img').css('height', sliderHeight + 'px' )
    }

    homeHeroSpacing();

    $(window).on('resize', function(){
      homeHeroSpacing();
    })
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js